import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import {
  AuthLayout,
  BottomTabsLayout,
  AuthGateLoader,
  ErrorBoundary,
  PageShell,
  RequireAuth,
  RequireGuest,
} from "@/components";
import {
  BookingPageAuthorized,
  BookingPageUnauthorized,
  MainPageAuthorized,
  MainPageUnauthorized,
  NewsDetails,
  NewsPage,
  SchedulePage,
  MyBookingsPage,
  ServicesPage,
  SignInPage,
  SignUpPage,
  ProfilePage,
  ContactsPage,
  RulesPage,
} from "@/pages";
import {useAuth} from "@/hooks/useAuth";

const RootRedirect = () => {
  const {isAuthenticated, isLoading} = useAuth();

  if (isLoading) return <AuthGateLoader />;

  return <Navigate to={isAuthenticated ? "/app" : "/guest"} replace />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <PageShell />,
    ErrorBoundary: ErrorBoundary,
    children: [
      {
        index: true,
        element: <RootRedirect />,
      },
      {
        path: "/auth",
        element: <RequireGuest />,
        children: [
          {
            element: <AuthLayout />,
            children: [{path: "sign-in", element: <SignInPage />}],
          },
          {path: "sign-up", element: <SignUpPage />},
        ],
      },
      {
        path: "/guest",
        element: <RequireGuest />,
        children: [
          {
            element: <BottomTabsLayout variant="unauthorized" />,
            children: [
              {index: true, element: <MainPageUnauthorized />},
              {path: "schedule", element: <SchedulePage />},
              {path: "booking", element: <BookingPageUnauthorized />},
              {path: "services", element: <ServicesPage />},
              {path: "news", element: <NewsPage />},
              {path: "contacts", element: <ContactsPage />},
              {path: "rules", element: <RulesPage />},
              {path: "news/:id", element: <NewsDetails />},
            ],
          },
        ],
      },
      {
        path: "/app",
        element: <RequireAuth />,
        children: [
          {
            element: <BottomTabsLayout variant="authorized" />,
            children: [
              {index: true, element: <MainPageAuthorized />},
              {path: "schedule", element: <SchedulePage withBackButton={true} />},
              {path: "booking", element: <BookingPageAuthorized />},
              {path: "services", element: <ServicesPage />},
              {path: "news", element: <NewsPage />},
              {path: "news/:id", element: <NewsDetails />},
              {path: "profile", element: <ProfilePage />},
              {path: "contacts", element: <ContactsPage />},
              {path: "rules", element: <RulesPage />},
              {path: "my-bookings", element: <MyBookingsPage />},
            ],
          },
        ],
      },
    ],
  },
]);

export const AppRouter = () => {
  return <RouterProvider router={router} />;
};
